import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('VisualExercise', LATEST_SCHEMA_VERSION.VisualExercise);
export default exerciseTypeVersionAdapter;